<div class="min-h-[calc(100vh-80px)] flex items-center justify-center p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div
    class="animate-fade-in-up bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 w-full max-w-lg p-8 md:p-10 text-center">
    <div class="mx-auto flex items-center justify-center h-24 w-24 rounded-full mb-6 shadow-inner"
      [ngClass]="reason() === 'not-found' ? 'bg-slate-100 dark:bg-slate-800' : 'bg-rose-50 dark:bg-rose-900/30'">
      <span class="material-icons-outlined text-5xl"
        [ngClass]="reason() === 'not-found' ? 'text-slate-400' : 'text-rose-500'">{{ icon() }}</span>
    </div>

    <p class="text-xs font-bold uppercase tracking-widest text-amber-500 mb-2">
      {{ reason() === 'not-found' ? '404' : '403' }}
    </p>
    <h1 class="text-2xl md:text-3xl font-black text-slate-800 dark:text-slate-100 mb-3 tracking-tight">{{ title() }}</h1>
    <p class="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-4">{{ description() }}</p>

    <p *ngIf="requestedPath()" class="text-xs text-slate-400 dark:text-slate-500 mb-8 break-all">
      URL: <span class="font-mono text-slate-600 dark:text-slate-300">{{ requestedPath() }}</span>
    </p>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <button type="button" (click)="goBack()"
        class="w-full py-3 text-sm font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-xl transition-all border border-slate-200 dark:border-slate-800">
        ย้อนกลับ
      </button>
      <a routerLink="/dashboard"
        class="w-full py-3 bg-amber-400 hover:bg-amber-500 text-white rounded-xl text-sm font-bold shadow-lg shadow-amber-200/50 active:scale-95 transition-all flex items-center justify-center">
        กลับหน้าหลัก
      </a>
    </div>
  </div>
</div>
